export class OnEnterKeyDirective implements angular.IDirective {
    public static $name = 'onEnterKey';

    public link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => {
        element.on('keydown keypress', (ev: JQueryEventObject) => {
            let enterKey = 13;

            if (ev.which === enterKey) {
                scope.$apply(() => {
                    scope.$eval(attrs['onEnterKey']);
                });

                ev.preventDefault();
            }
        }, null);

        scope.$on('$destroy', () => {
            element.off('keydown keypress');
        });
    }

    public static Factory() {
        let directive = () => {
            return new OnEnterKeyDirective();
        };

        directive['$inject'] = [];

        return directive;
    }
}
